/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/11/2023
 */

import React, { useContext, useEffect, useRef } from 'react'
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_DATE } from '../../Pages/CheckoutPage';
import styles from "./DateSelect.module.css"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation } from "swiper";
import { isMobile } from 'react-device-detect';
import { useGetnextTenDaysQuery } from '../../Store/Services/DatesService';
import { Backdrop, CircularProgress } from '@mui/material';

const DateSelect = () => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const datePrevRef = useRef(null);
    const dateNextRef = useRef(null);

    const { data: dates, isSuccess: isDatesSuccess, isLoading } = useGetnextTenDaysQuery();

    useEffect(() => {
        if (isDatesSuccess && !isLoading) {
            dispatch({ type: SET_DATE, payload: {
                dateId: dates[0]?.dateId,
                date: dates[0]?.date,
            }})
        }
    }, [dates])

    const onDateSelect = (id, value) => {
        dispatch({ type: SET_DATE, payload: {
            dateId: id,
            date: value,
        }})
    }

    return (
        <div className={styles.selectionContainer}>
            {isLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Swiper
                slidesPerView={isMobile ? 5 : 9}
                spaceBetween={10}
                slidesPerGroup={isMobile ? 5 : 9}
                freeMode={true}
                modules={[Navigation]}
                className={styles['sample-slider']}
                navigation={{
                    prevEl: datePrevRef.current,
                    nextEl: dateNextRef.current,
                }}
            >
                {isDatesSuccess && dates?.map(date => (
                    <SwiperSlide
                        key={date?.dateId}
                        className={styles.dateContainer}
                    >
                        <div>{date?.dayOfTheWeek.slice(0,3)}</div>
                        <div
                            className={`${styles.dateButton} ${checkoutData?.dateId == date?.dateId && styles.dateButtonSelected}`}
                            onClick={() => onDateSelect(date?.dateId, date?.date)}
                        >
                            {date?.dateDisplay}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div ref={datePrevRef} className="swiper-button-prev"></div>
            <div ref={dateNextRef} className="swiper-button-next"></div>
        </div>
    )
}

export default DateSelect